<template>
    <div v-if="componentLoaded" class="page-content account-view">
        <div class="section">
            <RouterLink to="/login" class="back-button" v-if="isUserLoggedIn">
                <SvgIcon
                    icon="icon--directional_arrow-left"
                    class="is-primary-dark"
                />
                <span class="ml-2 has-text-primary-dark"> Zurück</span>
            </RouterLink>
        </div>
        <div class="review-order__content container">
            <div
                class="section is-flex-tablet is-justify-content-space-between"
            >
                <h1 class="title is-3 has-text-grey is-uppercase">
                    {{
                        orderTrackingInfo.billingInformation.paymentMethod ===
                        'quote'
                            ? $t('orderDetails.quote')
                            : $t('orderDetails.header')
                    }}
                </h1>
                <b-button
                    v-if="
                        !orderTrackingInfo.legacyOrder &&
                        orderTrackingInfo.billingInformation.paymentMethod !==
                            'quote' &&
                        orderTrackingInfo.paymentStatus === 'PAYMENT_RECEIVED'
                    "
                    @click="showReOrderModal = true"
                    type="is-primary-dark"
                    :class="{
                        'is-fullwidth': [viewports.MOBILE.name].includes(
                            currentViewport
                        ),
                    }"
                >
                    {{ $t('orderDetails.actions.reOrder') }}
                </b-button>
                <b-button
                    v-if="
                        !orderTrackingInfo.legacyOrder &&
                        orderTrackingInfo.billingInformation.paymentMethod ===
                            'paypal' &&
                        orderTrackingInfo.paymentStatus === 'PAYMENT_PENDING'
                    "
                    @click="startOrderCompletion()"
                    type="is-primary-dark"
                    :class="{
                        'is-fullwidth': [viewports.MOBILE.name].includes(
                            currentViewport
                        ),
                    }"
                >
                    {{ $t('orderDetails.actions.payNow') }}
                </b-button>
                <!--b-button
          v-if="
            !orderTrackingInfo.legacyOrder &&
            orderTrackingInfo.billingInformation.paymentMethod === 'quote' &&
            orderTrackingInfo.paymentStatus === 'PAYMENT_PENDING'
          "
          @click="startOrderCompletion()"
          type="is-primary-dark"
          :class="{
            'is-fullwidth': [viewports.MOBILE.name].includes(currentViewport),
          }"
        >
          {{ $t("orderDetails.actions.orderNow") }}
        </b-button-->
            </div>
            <hr class="has-background-grey" />
            <div class="section">
                <h3 class="title is-4 has-text-grey mb-1 is-uppercase">
                    {{ $t('orderDetails.subHeader') }}
                </h3>
                <div class="columns is-gapless">
                    <div class="column is-half-tablet summary-details">
                        <div class="detail__list">
                            <div
                                v-for="detailEntry in orderDetails"
                                :key="`order-detail__${detailEntry.label}`"
                                class="detail__entry order-sum__entry"
                            >
                                <div class="entry__label">
                                    {{ detailEntry.label }}
                                </div>
                                <div class="entry__value">
                                    {{ detailEntry.value }}
                                </div>
                            </div>
                            <div
                                class="detail__entry order-sum__entry"
                                v-if="
                                    orderTrackingInfo.customerRemarks &&
                                    orderTrackingInfo.customerRemarks
                                        .referenceNumber.length > 0
                                "
                            >
                                <div class="entry__label">
                                    {{
                                        $t(
                                            'checkout.paymentDetails.inputLabels.referenceNumber'
                                        )
                                    }}
                                </div>
                                <div class="entry__value">
                                    {{
                                        orderTrackingInfo.customerRemarks
                                            .referenceNumber
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="columns is-gapless">
                    <div class="column">
                        <hr class="has-background-grey" />
                        <h3
                            class="detail__header title is-4 is-uppercase has-text-grey"
                        >
                            {{ $t('orderDetails.labels.shippingAddress') }}
                        </h3>
                        <div class="summary-details">
                            <div class="detail__list">
                                <div
                                    v-for="detailEntry in orderShippingAddress"
                                    :key="`order-shipping-detail__${detailEntry.label}`"
                                    class="detail__entry order-sum__entry"
                                >
                                    <div class="entry__label">
                                        {{ detailEntry.label }}
                                    </div>
                                    <div class="entry__value">
                                        {{ detailEntry.value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <hr class="has-background-grey" />
                        <h3
                            class="detail__header title is-4 is-uppercase has-text-grey"
                        >
                            {{ $t('orderDetails.labels.billingAddress') }}
                        </h3>
                        <div class="summary-details">
                            <div class="detail__list">
                                <div
                                    v-for="detailEntry in orderBillingAddress"
                                    :key="`order-billing-detail__${detailEntry.label}`"
                                    class="detail__entry order-sum__entry"
                                >
                                    <div class="entry__label">
                                        {{ detailEntry.label }}
                                    </div>
                                    <div class="entry__value">
                                        {{ detailEntry.value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="has-background-grey" />
            <div class="section">
                <div class="columns">
                    <div class="column is-full-tablet">
                        <div class="order-sum summary-details">
                            <h3 class="title is-4 has-text-grey">
                                {{ $t('orderDetails.labels.items') }}
                            </h3>
                            <div class="main-cart p-0">
                                <cart-item-list
                                    :cart-items="orderTrackingInfo.items"
                                    :is-editable="false"
                                    has-minimal-items
                                    :is-legacy="orderTrackingInfo.legacyOrder"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="has-background-grey" />
            <div class="section">
                <div class="columns">
                    <div class="column is-half-tablet">
                        <div class="order-sum summary-details">
                            <h3 class="title is-4 has-text-grey is-uppercase">
                                {{ $t('orderDetails.labels.summary') }}
                            </h3>
                            <div class="detail__entry">
                                <span class="order-sum__label"
                                    >{{
                                        orderPaymentDetails.paymentMethod.label
                                    }}: </span
                                ><span class="order-sum__value">{{
                                    orderPaymentDetails.paymentMethod.value
                                }}</span>
                            </div>
                            <div class="detail__entry">
                                <span class="order-sum__label"
                                    >{{ orderDetails.productionTime.label }}:
                                </span>
                                <span class="order-sum__value">{{
                                    $tc(
                                        'checkout.productionTimeDays',
                                        orderTrackingInfo.estimatedProductionTimeDays
                                    )
                                }}</span>
                            </div>
                            <div class="detail__entry">
                                <span class="order-sum__label"
                                    >{{
                                        $t('orderDetails.labels.deliveryTime')
                                    }}: </span
                                ><span class="order-sum__value">
                                    {{
                                        $tc(
                                            'checkout.productionTimeDays',
                                            orderTrackingInfo.shippingMethod
                                                .shippingTimeDays
                                        )
                                    }}</span
                                >
                            </div>
                            <div class="detail__entry">
                                <span class="order-sum__label"
                                    >Voraussichtl. Gesamtlieferzeit</span
                                ><strong class="order-sum__value">
                                    {{
                                        $tc(
                                            'checkout.productionTimeDays',
                                            orderTrackingInfo.shippingMethod
                                                .shippingTimeDays +
                                                orderTrackingInfo.estimatedProductionTimeDays
                                        )
                                    }}</strong
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="order-sum summary-details">
                    <div class="detail__list mr-0">
                        <div class="detail__entry order-sum__order-sum mr-5">
                            <div class="order-sum__label">
                                {{ orderPaymentDetails.orderSum.label }}
                            </div>
                            <div class="order-sum__value">
                                {{
                                    orderPaymentDetails.orderSum.value
                                        | toCents
                                        | currency
                                }}
                            </div>
                        </div>
                        <div class="detail__entry order-sum__order-sum mr-5">
                            <div class="order-sum__label">
                                {{ orderPaymentDetails.shippingPrice.label }}
                            </div>
                            <div class="order-sum__value">
                                {{ orderPaymentDetails.shippingPrice.value }}
                            </div>
                        </div>
                        <div
                            class="detail__entry order-sum__entry--primary has-background-primary-dark has-text-light mt-5 is-multiline columns is-mobile"
                        >
                            <div
                                class="column order-sum__label is-three-fifths-mobile is-half"
                            >
                                <span class="title is-4 has-text-white">{{
                                    orderPaymentDetails.sum.label
                                }}</span>
                            </div>
                            <div
                                class="column is-two-fifths-mobile has-text-right is-half"
                            >
                                <strong
                                    class="order-sum__value title is-4 has-text-white mr-5"
                                >
                                    {{
                                        orderPaymentDetails.sum.value
                                            | toCents
                                            | currency
                                    }}
                                </strong>
                            </div>
                            <div class="column is-full-mobile is-full">
                                <span>{{
                                    $t('checkout.cart.includingVAT')
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="has-text-right">
                    <b-button
                        v-if="
                            !orderTrackingInfo.legacyOrder &&
                            orderTrackingInfo.billingInformation
                                .paymentMethod === 'paypal' &&
                            orderTrackingInfo.paymentStatus ===
                                'PAYMENT_PENDING'
                        "
                        @click="startOrderCompletion()"
                        type="is-primary-dark"
                        :class="{
                            'is-fullwidth': [viewports.MOBILE.name].includes(
                                currentViewport
                            ),
                        }"
                    >
                        {{ $t('orderDetails.actions.payNow') }}
                    </b-button>
                    <!--b-button
            v-if="
              !orderTrackingInfo.legacyOrder &&
              orderTrackingInfo.billingInformation.paymentMethod === 'quote' &&
              orderTrackingInfo.paymentStatus === 'PAYMENT_PENDING'
            "
            @click="startOrderCompletion()"
            type="is-primary-dark"
            :class="{
              'is-fullwidth': [viewports.MOBILE.name].includes(currentViewport),
            }"
          >
            {{ $t("orderDetails.actions.orderNow") }}
          </b-button-->
                </div>
            </div>
            <b-modal
                v-model="showReOrderModal"
                has-modal-card
                @close-modal="showReOrderModal = false"
                style="width: auto"
            >
                <div class="modal-card">
                    <div class="modal-card-head">
                        <h1 class="card-header-title">
                            {{
                                $t('orderDetails.reOrderModal.headline', {
                                    orderNumber: orderTrackingInfo.orderNumber,
                                })
                            }}
                        </h1>
                        <h1 class="card-header-title">
                            ({{
                                $tc(
                                    'orderDetails.reOrderModal.nItems',
                                    orderTrackingInfo.items.length
                                )
                            }})
                        </h1>
                    </div>
                    <div class="modal-card-body">
                        <div class="columns is-multiline">
                            <div class="column is-full-tablet">
                                <div class="order-sum summary-details">
                                    <div class="detail__list mx-5 mb-4 p-3">
                                        <div
                                            class="detail__entry order-sum__order-sum"
                                        >
                                            <div class="order-sum__label">
                                                {{
                                                    orderPaymentDetails.orderSum
                                                        .label
                                                }}
                                            </div>
                                            <div class="order-sum__value">
                                                {{
                                                    orderPaymentDetails.orderSum
                                                        .value
                                                        | toCents
                                                        | currency
                                                }}
                                            </div>
                                        </div>
                                        <div
                                            class="detail__entry order-sum__order-sum"
                                        >
                                            <div class="order-sum__label">
                                                {{
                                                    orderPaymentDetails
                                                        .shippingPrice.label
                                                }}
                                            </div>
                                            <div class="order-sum__value">
                                                {{
                                                    orderPaymentDetails
                                                        .shippingPrice.value
                                                }}
                                            </div>
                                        </div>
                                        <div
                                            class="detail__entry order-sum__entry--primary has-background-primary-dark has-text-light mt-5 is-multiline columns is-mobile"
                                        >
                                            <div
                                                class="column order-sum__label is-three-fifths-mobile is-half"
                                            >
                                                <span
                                                    class="title is-4 has-text-white"
                                                    >{{
                                                        orderPaymentDetails.sum
                                                            .label
                                                    }}</span
                                                >
                                            </div>
                                            <div
                                                class="column is-two-fifths-mobile has-text-right is-half"
                                            >
                                                <strong
                                                    class="order-sum__value title is-4 has-text-white mr-5"
                                                >
                                                    {{
                                                        orderPaymentDetails.sum
                                                            .value
                                                            | toCents
                                                            | currency
                                                    }}
                                                </strong>
                                            </div>
                                            <div
                                                class="column is-full-mobile is-full"
                                            >
                                                <span>{{
                                                    $t(
                                                        'checkout.cart.includingVAT'
                                                    )
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-card-foot is-justify-content-flex-end">
                        <div class="buttons is-right mr-4">
                            <button
                                @click="reOrder"
                                class="button is-primary-dark px-6"
                            >
                                {{ $t('orderDetails.actions.reOrder') }}
                                <SvgIcon
                                    icon="icon--directional_arrow-right"
                                    class="is-light ml-5"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgIcon from '../svg/SvgIcon';
import CartItem from '../checkout/CartItem';
import CartItemList from '../checkout/CartItemList';
import ModalView from '../shared/ModalView';
import { $axios } from '../../store/modules/axios-instance';
import { eventBus } from '../../events/event-bus';
import i18n from '../../i18n';
import { viewports } from '../../store/constants/viewports';

const API_URL = process.env.VUE_APP_FULFILLMENT_API_BASE_URL;

export default {
    name: 'OrderDetails',
    components: { CartItemList, CartItem, SvgIcon, ModalView },
    data() {
        return {
            componentLoaded: false,
            showReOrderModal: false,
            viewports,
        };
    },
    async created() {
        this.fetchCMSData();
        try {
            await this.$store.dispatch('fetchOrderTrackingInfo', {
                orderId: this.$route.params.orderId,
            });
            this.componentLoaded = true;
        } catch (e) {
            console.log(e);
        }
    },
    computed: {
        ...mapGetters([
            'orderTrackingInfo',
            'isUserLoggedIn',
            'currentViewport',
        ]),
        orderDetails() {
            if (this.orderTrackingInfo.shippingMethod) {
                return {
                    orderID: {
                        label:
                            this.orderTrackingInfo.billingInformation
                                .paymentMethod === 'quote'
                                ? this.$i18n.t(
                                      'orderDetails.labels.quoteNumber'
                                  )
                                : this.$i18n.t(
                                      'orderDetails.labels.orderNumber'
                                  ),
                        value: this.orderTrackingInfo.orderNumber,
                    },
                    orderDate: {
                        label:
                            this.orderTrackingInfo.billingInformation
                                .paymentMethod === 'quote'
                                ? this.$i18n.t(
                                      'orderDetails.labels.quoteCreatedAt'
                                  )
                                : this.$i18n.t('orderDetails.labels.createdAt'),
                        value: this.$i18n.d(
                            new Date(this.orderTrackingInfo.createdAt)
                        ),
                    },
                    orderState: {
                        label: this.$i18n.t('orderDetails.labels.orderStatus'),
                        value: this.$i18n.t(
                            `checkout.orderStatusLabels.${this.orderTrackingInfo.orderStatus}`
                        ),
                    },
                    productionTime: {
                        label: this.$i18n.t(
                            'orderDetails.labels.productionTime'
                        ),
                        value: this.$i18n.tc(
                            'checkout.productionTimeDays',
                            this.orderTrackingInfo.estimatedProductionTimeDays
                        ),
                    },
                    shippingTime: {
                        label: `+ ${this.$i18n.t(
                            'orderDetails.labels.deliveryTime'
                        )}`,
                        value: this.$i18n.tc(
                            'checkout.productionTimeDays',
                            this.orderTrackingInfo.shippingMethod
                                .shippingTimeDays +
                                this.orderTrackingInfo
                                    .estimatedProductionTimeDays || 0
                        ),
                    },
                };
            }
        },
        orderShippingAddress() {
            if (this.orderTrackingInfo.shippingInformation) {
                return {
                    customerName: {
                        label: this.$i18n.t('orderDetails.labels.name'),
                        value: `${this.orderTrackingInfo.shippingInformation.firstname} ${this.orderTrackingInfo.shippingInformation.lastname}`,
                    },
                    customerEmail: {
                        label: this.$i18n.t('orderDetails.labels.email'),
                        value: this.orderTrackingInfo.email,
                    },
                    customerStreet: {
                        label: this.$i18n.t('orderDetails.labels.address'),
                        value: `${this.orderTrackingInfo.shippingInformation.street}`,
                    },
                    customerZipAndCity: {
                        label: this.$i18n.t('orderDetails.labels.city'),
                        value: `${this.orderTrackingInfo.shippingInformation.postalCode} ${this.orderTrackingInfo.shippingInformation.city}`,
                    },
                    customerCountry: {
                        label: this.$i18n.t('orderDetails.labels.country'),
                        value: `${this.orderTrackingInfo.shippingInformation.country.name}`,
                    },
                };
            }
        },
        orderBillingAddress() {
            if (this.orderTrackingInfo.billingInformation) {
                return {
                    customerName: {
                        label: this.$i18n.t('orderDetails.labels.name'),
                        value: `${this.orderTrackingInfo.billingInformation.firstname} ${this.orderTrackingInfo.billingInformation.lastname}`,
                    },
                    customerEmail: {
                        label: this.$i18n.t('orderDetails.labels.email'),
                        value: this.orderTrackingInfo.email,
                    },
                    customerStreet: {
                        label: this.$i18n.t('orderDetails.labels.address'),
                        value: `${this.orderTrackingInfo.billingInformation.street}`,
                    },
                    customerZipAndCity: {
                        label: this.$i18n.t('orderDetails.labels.city'),
                        value: `${this.orderTrackingInfo.billingInformation.postalCode} ${this.orderTrackingInfo.billingInformation.city}`,
                    },
                    customerCountry: {
                        label: this.$i18n.t('orderDetails.labels.country'),
                        value: `${this.orderTrackingInfo.billingInformation.country.name}`,
                    },
                };
            }
        },
        orderPaymentDetails() {
            if (this.orderTrackingInfo.positionPrice) {
                return {
                    orderSum: {
                        label: this.$i18n.t(
                            'orderDetails.labels.positionPrice'
                        ),
                        value: `${this.orderTrackingInfo.positionPrice.toFixed(
                            2
                        )}`,
                    },
                    shippingPrice: {
                        label: this.$i18n.t(
                            'orderDetails.labels.shippingPrice'
                        ),
                        value: `${(
                            this.orderTrackingInfo.shippingTotal *
                            ((100 +
                                this.orderTrackingInfo.price.calculatedTaxes
                                    .taxRate) /
                                100)
                        ).toFixed(2)}`,
                    },
                    sum: {
                        label: this.$i18n.t('orderDetails.labels.amountTotal'),
                        value: `${parseFloat(
                            this.orderTrackingInfo.amountTotal
                        ).toFixed(2)}`,
                    },
                    paymentMethod: {
                        label: this.$i18n.t(
                            'checkout.paymentDetails.paymentMethod'
                        ),
                        value: this.$i18n.t(
                            `checkout.paymentMethodLabels.${this.orderTrackingInfo.billingInformation.paymentMethod}`
                        ),
                    },
                };
            }
        },
    },
    methods: {
        async reOrder() {
            try {
                this.showReOrderModal = false;
                await $axios.post(
                    `${API_URL}/checkout/order/${this.orderTrackingInfo._id}`
                );
                eventBus.notification({
                    type: 'success',
                    header: 'Bestellung wurde erneut aufgegeben',
                    body: 'Sie erhalten eine Bestätigung per E-Mail.',
                });
            } catch (e) {
                eventBus.notification({
                    type: 'warning',
                    header: i18n.t('notifications.warning.header'),
                    body: i18n.t('notifications.warning.body'),
                });
            }
        },

        startOrderCompletion() {
            this.$router.push({
                name: 'UpdateOrder',
                params: { orderId: this.orderTrackingInfo._id },
            });
        },
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', { urlSlug: '/' });
        },
    },
};
</script>
